<template>
    <div class="product-list-container">
        <div v-if="!loading" class="product-list-row">
            <product-card
                v-for="(product, $index) in products"
                :key="product.productId"
                :product="product"
                :position="$index + 1"
            ></product-card>
        </div>
        <div v-if="!loading && products.length === 0" class="empty-product-list" data-cy="empty-product-list">
            <span>{{ $t('shop.empty') }}</span>
        </div>
        <div v-if="loading" class="products-loading">
            <div class="page-spinner-wrapper">
                <span class="spinner-circle"></span>
            </div>
        </div>
    </div>
</template>

<script>
import productCard from '@/components/common/product-card';

export default {
    name: 'ProductList',
    components: {
        productCard,
    },
    props: {
        products: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style lang="less" scoped>
.product-list-container {
    margin: auto;
    min-height: 350px;
    width: 100%;
    .product-list-row {
        display: flex;
        flex-wrap: wrap;
        margin: -10px;
    }
    .empty-product-list {
        display: flex;
        font-size: 30px;
        font-weight: bold;
        justify-content: center;
        margin-top: 100px;
    }
    .products-loading {
        align-items: center;
        display: flex;
        justify-content: center;
        min-height: 350px;
        .spinner-circle {
            border: 10px solid #999;
            border-top: 10px solid #40d0ba;
            height: 60px;
            width: 60px;
        }
    }
}
@media (max-width: 768px) {
    .product-list-container .product-list-row {
        margin: 0 10px;
    }
}
@media (max-width: 480px) {
    .product-list-container .product-list-row {
        margin: 10px 20px;
    }
}
</style>
